export const arrayMenuLimpieza = [
  {
    id: 1,
    key: 'configuracion',
    name: 'Configuración',
    vista: '#CONFIGURACION',
    arraySubItem: [
      {
        id: 1,
        title: 'Tipos de Edificación',
        submenu: 'type-of-building',
        showPanel: false,
        vista: '#TIPOS DE EDIFICACION',
        content: {
          headerPanel: 'table-type-of-building',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 2,
        title: 'Creación de Actividades de Limpieza',
        submenu: 'creation-of-cleaning-activities',
        showPanel: false,
        vista: '#CREACION DE ACTIVIDADES DE LIMPIEZA',
        content: {
          headerPanel: 'table-creation-of-cleaning-activities',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 3,
        title: 'Creación de Celulares',
        submenu: 'creation-of-cellphones',
        showPanel: false,
        vista: '#CREACION DE CELULARES',
        content: {
          headerPanel: 'table-creation-of-cellphones',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 4,
        title: 'Programación de Limpieza',
        submenu: 'cleaning-schedule',
        showPanel: false,
        vista: '#PROGRAMACION DE LIMPIEZA',
        content: {
          headerPanel: 'table-cleaning-schedule',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
    ],
  },
  {
    id: 2,
    key: 'asignaciones',
    name: 'Asignaciones',
    vista: '#ASIGNACIONES',
    arraySubItem: [
      {
        id: 1,
        title: 'Asignación de Celulares',
        submenu: 'assignment-of-cellphones',
        showPanel: false,
        vista: '#ASIGNACION DE CELULARES',
        content: {
          headerPanel: 'table-assignment-of-cellphones',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
      {
        id: 2,
        title: 'Asignación de Programaciones de Limpieza',
        submenu: 'assignment-of-cleaning-schedules',
        showPanel: false,
        vista: '#ASIGNACION DE PROGRAMACIONES DE LIMPIEZA',
        content: {
          headerPanel: 'table-assignment-of-cleaning-schedules',
        },
        closable: false,
        idToEdit: '',
        loadingTable: false,
      },
    ],
  },
  {
    id: 3,
    key: 'reportes-limpieza',
    name: 'Reportes',
    vista: '#REPORTES LIMPIEZA',
    arraySubItem: [
      {
        id: 1,
        title: 'Histórico de Censos',
        showPanel: false,
        vista: '#HISTORICO DE CENSOS',
        content: {
          headerPanel: 'form-census-history',
        },
        closable: true,
        submenu: 'reports-census-history',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 2,
        title: 'Estado de Limpieza',
        showPanel: false,
        vista: '#ESTADO DE LIMPIEZA',
        content: {
          headerPanel: 'form-cleaning-status',
        },
        closable: true,
        submenu: 'reports-cleaning-status',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
    ],
  },
]
